import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

type ItemProps = {
    value: string;
    label: string;
};

type OWSelectProps = {
    label: string;
    value: string;
    onChange: (event: SelectChangeEvent<string>, child: React.ReactNode) => void;
    items: ItemProps[];
    error?: boolean;
    labelId: string;
    disabled?: boolean;
};

const OWSelect = ({ label, labelId, onChange, value, error, items, disabled }: OWSelectProps) => {
    return (
        <FormControl fullWidth>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select value={value} onChange={onChange} label={label} labelId={labelId} error={error} disabled={disabled}>
                {items.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                        {item.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default OWSelect;
